export default "__VITE_ASSET__CUsmBJ3j__"